import script from "./GeneralInfomation.vue?vue&type=script&setup=true&lang=js"
export * from "./GeneralInfomation.vue?vue&type=script&setup=true&lang=js"

import "./GeneralInfomation.vue?vue&type=style&index=0&id=4ef1a528&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ef1a528"]])

export default __exports__